import { render, staticRenderFns } from "./FacebookSolid.vue?vue&type=template&id=1e32cff8&"
import script from "./FacebookSolid.vue?vue&type=script&lang=ts&"
export * from "./FacebookSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports